import {setDefaultFilterState} from "@SearchResults/reducers/filterSlice";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";

export default function useSetDefaultFilters() {
    const dispatch = useAppDispatch()
    const setDefaultFilters = () => {
        dispatch(setDefaultFilterState())
    }

    return {
        setDefaultFilters,
    }
}